import { ApolloLink } from '@apollo/client';
import { createAppSyncSubscriptionWebsocketLink } from './appSyncSubscriptionWebSocketLink';
import { createAppSyncHttpLink } from './appSyncHttpLink';
import { getMainDefinition } from '@apollo/client/utilities';

export const createAppSyncHybridLink = async ({
  appSyncApiUrl,
  appSyncApiWsUrl,
  getJwtToken,
}) =>
  ApolloLink.split(
    isSubscriptionOperation,
    (await createAppSyncSubscriptionWebsocketLink({
      appSyncApiUrl,
      appSyncApiWsUrl,
      getJwtToken,
    })) as any,
    createAppSyncHttpLink({ appSyncApiUrl, getJwtToken })
  );

const isSubscriptionOperation = ({ query }) => {
  const { kind, operation } = getMainDefinition(query) as any;
  return kind === 'OperationDefinition' && operation === 'subscription';
};
